 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE from '@/components/xhtml/01_Title'
 import XHTML00_FRONT_MA from '@/components/xhtml/00_Front_Ma'
 import XHTML03_DEDICATI from '@/components/xhtml/03_Dedicati'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_LIST_OF from '@/components/xhtml/05_List_of'
 import XHTML06_PREFACE from '@/components/xhtml/06_Preface'
 import XHTML07_ACKNOWLE from '@/components/xhtml/07_Acknowle'
 import XHTML08_PART_I_ from '@/components/xhtml/08_PART_I_'
 import XHTML09_1_WAR_AN from '@/components/xhtml/09_1_War_an'
 import XHTML10_PART_II_ from '@/components/xhtml/10_PART_II_'
 import XHTML11_2_THE_PO from '@/components/xhtml/11_2_The_Po'
 import XHTML12_3_THE_MO from '@/components/xhtml/12_3_The_Mo'
 import XHTML13_PART_III from '@/components/xhtml/13_PART_III'
 import XHTML14_4_SPENDI from '@/components/xhtml/14_4_Spendi'
 import XHTML15_5_VOTING from '@/components/xhtml/15_5_Voting'
 import XHTML16_6_CASE_S from '@/components/xhtml/16_6_Case_S'
 import XHTML17_7_CASE_S from '@/components/xhtml/17_7_Case_S'
 import XHTML18_PART_IV_ from '@/components/xhtml/18_PART_IV_'
 import XHTML19_8_SUMMAR from '@/components/xhtml/19_8_Summar'
 import XHTML20_PART_V_ from '@/components/xhtml/20_PART_V_'
 import XHTML21_A_TECHNI from '@/components/xhtml/21_A_Techni'
 import XHTML22_B_ALTERN from '@/components/xhtml/22_B_Altern'
 import XHTML23_C_SUMMAR from '@/components/xhtml/23_C_Summar'
 import XHTML24_D_ROBUST from '@/components/xhtml/24_D_Robust'
 import XHTML24_NOTES from '@/components/xhtml/24_Notes'
 import XHTML25_BIBLIOGR from '@/components/xhtml/25_Bibliogr'
 import XHTML26_INDEX from '@/components/xhtml/26_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_List_of",
 			"name" : "xhtml/05_List_of",
 			"component" : XHTML05_LIST_OF
 		},
 		{
 			"path" : "/xhtml/06_Preface",
 			"name" : "xhtml/06_Preface",
 			"component" : XHTML06_PREFACE
 		},
 		{
 			"path" : "/xhtml/07_Acknowle",
 			"name" : "xhtml/07_Acknowle",
 			"component" : XHTML07_ACKNOWLE
 		},
 		{
 			"path" : "/xhtml/08_PART_I_",
 			"name" : "xhtml/08_PART_I_",
 			"component" : XHTML08_PART_I_
 		},
 		{
 			"path" : "/xhtml/09_1_War_an",
 			"name" : "xhtml/09_1_War_an",
 			"component" : XHTML09_1_WAR_AN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js